export default "__VITE_ASSET__Tyu$J9fe__"